import React from 'react';
import PropTypes from 'prop-types';

const TextIcon = ({ className, children }) => (
  <div className={className}>{children}</div>
);

TextIcon.propTypes = {
  className: PropTypes.string.isRequired,
  children: PropTypes.string.isRequired,
};

export default TextIcon;
